<ng-container
  *appLet="{
    cultureCode: culture$ | async,
    cultureName: cultureName$ | async,
    cultureShortName: cultureShortName$ | async,
    searchInput: searchInput$ | async,
    tripType: tripType$ | async,
    currencies: currencies$ | async,
    selectedCurrency: selectedCurrency$ | async,
    selectedCurrencyPrefix: selectedCurrencyPrefix$ | async,
    selectedCurrencyPrefixIncludeAll: selectedCurrencyPrefixIncludeAll$ | async,
    selectedCurrencySuffix: selectedCurrencySuffix$ | async,
    bookingCurrency: bookingCurrency$ | async,
    loggedInUser: loggedInUser$ | async,
    culture: (culture$ | async) || FALLBACK_CULTURE,
    isBookingPath: isBookingPath$ | async,
    isModifyPath: isModifyPath$ | async,
    isUpgradePath: isUpgradePath$ | async,
    showModify: getShowModifySearchWidget$ | async,
    showModifyNavbar: getShowModifySearchNavbarWidget$ | async,
    isFlightsPage: isFlightsPage$ | async,
    isHomePage: isHomePage$ | async,
    isFlowPage: isFlowPage$ | async,
    isSupportPage: isSupportPage$ | async,
    mobileStyle: mobileStyle$ | async,
    stations: stations$ | async,
    feature633IsOn: gbs.growthBook.isOn(GrowthBookFeatureKeys.FEAT_US633_IMPROVED_LANG_CURRENCY_PICKER),
    feature633StringValue: gbs.growthBook.getFeatureValue(GrowthBookFeatureKeys.FEAT_US633_IMPROVED_LANG_CURRENCY_PICKER, ''),
    feature2389IsOn: gbs.isVariantOfExperimentEnabled('feat-002389-turning-off-cultures', 'b'),
    feature1893IsOn: gbs.isVariantOfExperimentEnabled('feat-001893-car-rental-header-popup-deeplink', 'b'),
    feature2688IsOn: gbs.isVariantOfExperimentEnabled('feat-002688-online-check-in', true),
    feature3367IsOn: gbs.isVariantOfExperimentEnabled('feat-003367-book-tab-underlined', 'b'),
    currentFeat3322Value: gbs.growthBook.getFeatureValue('feat-003322-your-trip-navigation-bar-placement', ''),
    navbarCopy: navbarCopy$ | async
  } as $comp"
>
  <header class="app-header container">
    <div class="header-wrapper mx-3 mx-sm-0">
      <nav
        class="navbar"
        [ngClass]="{
          'navbar--auto-height': is1433TopMenuReorderingEnabled,
        }"
        aria-label="Main"
      >
        <div class="grid w-100" [ngClass]="{ 'me-3': !$comp.mobileStyle }">
          <div
          class="brand g-col-6"
            [ngClass]="{
              'flex-grow-0': $comp.isFlightsPage && !$comp.isUpgradePath,
              'g-col-md-2': !$comp.mobileStyle && !$comp.isFlowPage
              }"
          >
            <a class="navbar-brand" [routerLink]="['/' + $comp.culture]">
              <img
                src="https://assets.flynorse.com/static/site/NorseLogoWhite.svg"
                class="img-fluid logo"
                alt="Norse Atlantic Airways Logo"
              />
            </a>
          </div>
          <div
            *ngIf="!$comp.mobileStyle && !$comp.isFlowPage"
            class="g-col-md-7 g-col-lg-8 d-flex justify-content-center align-middle fs-5">
            @if (is3322TopMenuReorderingEnabled && $comp.navbarCopy) {
              <div class="w-100">
                <app-top-navbar
                  [cmsCopy]="cmsAppCopy.header"
                  [loggedInUser]="$comp.loggedInUser"
                  [currentValue]="$comp.currentFeat3322Value"
                  [navbarCopy]="$comp.navbarCopy"
                  (bookClick)="onBookClick()"
                  (openLoginModal)="openLoginModal()"
                ></app-top-navbar>
              </div>
            } @else if (is1433TopMenuReorderingEnabled) {
              <div class="w-100">
                <app-top-menu
                  [headerCopy]="cmsAppCopy.header"
                  [hasStations]="!!$comp.stations"
                  [isFlifoEnabled]="featureFlagService.isFeatureActive(FeatureFlagsEnum.FLIFO)"
                  (bookNowClick)="onBookClick(true)"
                ></app-top-menu>
              </div>
            } @else {
              <div class="nav-container d-flex justify-content-between align-items-center">
                @if($comp.stations) {
                  @if($comp.feature3367IsOn) {
                  <div
                    class="nav-item text-white p-0"
                    [routerLink]="cmsCopy.book.link"
                    [routerLinkActiveOptions]="{ exact: true }"
                    routerLinkActive="current"
                  >
                    <div>{{ cmsCopy.book.name }}</div>
                  </div>
                  } @else {
                    <div
                      class="nav-item text-white p-0" 
                      (click)="onBookClick()"
                    >
                      <div>{{ cmsCopy.book.name }}</div>
                    </div>
                  }
                }
                @if ($comp.feature1893IsOn && cmsCopy.cars && $comp.stations) {
                  <div
                    class="nav-item text-white p-0"
                    [routerLink]="cmsCopy.cars.link"
                    routerLinkActive="current"
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    <div>{{ cmsCopy.cars.name }}</div>
                  </div>
                }
                <div
                  [routerLink]="cmsCopy.support.link"
                  [ngClass]="{ current: $comp.isSupportPage }"
                  class="nav-item text-white p-0">
                    <div>{{ cmsCopy.support.name }}</div>
                </div>
                <div
                  *ngIf="$comp.stations"
                  [routerLink]="cmsCopy.trips.link"
                  routerLinkActive="current"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="nav-item text-white p-0"
                >
                  <div>{{ cmsCopy.trips.name }}</div>
                </div>
                <div
                  *ngIf="
                    featureFlagService.isFeatureActive(FeatureFlagsEnum.FLIFO) &&
                    $comp.stations
                  "
                  class="nav-item text-white p-0"
                  [routerLink]="cmsCopy.flightStatus.link"
                  routerLinkActive="current"
                >
                  <div>{{ cmsCopy.flightStatus.name }}</div>
                </div>
                @if (featureFlagService.isFeatureActive(FeatureFlagsEnum.LOG_IN) && $comp.stations) {
                  @if (!$comp.loggedInUser) {
                    <div
                      class="nav-item text-white p-0"
                      (click)="openLoginModal()"
                    >
                      <div>{{ cmsCopy.login }}</div>
                    </div>
                  } @else {
                    <app-header-menu-user
                      [username]="$comp?.loggedInUser?.name?.first"
                      [yourAccountLink]="cmsCopy.yourAccount.link"
                      [yourAccountNameLabel]="cmsCopy.yourAccount.name"
                      [logoutLabel]="cmsCopy.logout"
                    ></app-header-menu-user>
                  }
                }
              </div>
            }
          </div>
          <div class="secondary g-col-6 d-flex align-items-center justify-content-end"
            [ngClass]="{
              'g-col-md-3 g-col-lg-2': !$comp.isFlowPage
            }">
            @if (
              featureFlagService.isFeatureActive(FeatureFlagsEnum.LOG_IN) &&
              $comp.stations &&
              !$comp.mobileStyle &&
              !$comp.isFlowPage &&
              is1433TopMenuReorderingEnabled
            ) {
              @if (!$comp.loggedInUser) {
                <div
                  class="nav-item-user"
                  (click)="openLoginModal()"
                >
                  <app-svg-icon
                    fill="transparent"
                    stroke="white"
                    icon="top-nav-profile"
                    [width]="16"
                    [height]="16"
                  ></app-svg-icon>
                </div>
              } @else {
                <app-header-menu-user
                  [username]="getInitialsFromUser($comp?.loggedInUser?.name)"
                  [yourAccountLink]="cmsCopy.yourAccount.link"
                  [yourAccountNameLabel]="cmsCopy.yourAccount.name"
                  [logoutLabel]="cmsCopy.logout"
                  className="nav-item-user"
                  [withArrow]="false"
                ></app-header-menu-user>
              }
            }
            <div class="navbar-nav">
              @if (!$comp.feature2389IsOn) {
                <app-culture-dropdown
                [collapseCultures]="collapseCultures"
                [cultureCode]="$comp.cultureCode"
                [cultureName]="$comp.cultureName"
                ></app-culture-dropdown>
              }
              <div
                class="dropdown currency"
                *ngIf="$comp.currencies?.length"
              >
                <button
                  type="button"
                  id="currencyCollapse"
                  role="button"
                  [ngClass]="{
                    collapsed: collapseCurrencies,
                    adisabled: !$comp.isHomePage && $comp.bookingCurrency,
                    'currency-button-dark hoverable-scale': $comp.feature633IsOn && $comp.feature633StringValue !== 'a',
                    'currency-button-light': !$comp.feature633IsOn || $comp.feature633StringValue === 'a'
                  }"
                  [attr.aria-expanded]="!collapseCurrencies"
                  aria-controls="currency-dropdown"
                  (click)="collapseCurrencies = !collapseCurrencies"
                  appOnTap
                  [tooltip]="!$comp.isHomePage && $comp.bookingCurrency && ($comp.feature633StringValue === 'c' || $comp.feature633StringValue === 'd') ? currencyPickerDisabled : undefined"
                  containerClass="tooltip-clickable"
                  placement="auto"
                  tooltipTrigger="click"
                  #currencyTooltip="bs-tooltip"
                  (clickOutside)="hideTooltip()"
                >
                @if($comp.feature633IsOn && $comp.feature633StringValue !== 'a') {
                  {{
                    getSelectedCurrencyWithSuffix(
                      $comp.selectedCurrencyPrefixIncludeAll,
                      $comp.selectedCurrencySuffix,
                      $comp.selectedCurrency
                    )
                  }}
                } @else {
                  {{
                    getSelectedCurrencyWithPrefixSuffix(
                      $comp.selectedCurrencyPrefix,
                      $comp.selectedCurrencySuffix,
                      $comp.selectedCurrency
                    )
                  }}
                }

                </button>
                <ul
                  *ngIf="$comp.isHomePage || !$comp.bookingCurrency"
                  class="dropdown-menu"
                  id="currency-dropdown"
                  aria-labelledby="navbarDropdown2"
                  [collapse]="collapseCurrencies"
                  [isAnimated]="false"
                  [ngClass]="{'dropdown-container': $comp.feature633IsOn && $comp.feature633StringValue !== 'a'}"
                >
                  <li
                    *ngFor="let currency of $comp.currencies"
                    (mousedown)="
                      changeCurrency(
                        currency.currencyCode,
                        $comp.isFlightsPage ?? false,
                        $comp.selectedCurrency
                      )
                    "
                    [ngClass]="{
                      'currency-item': $comp.feature633IsOn && $comp.feature633StringValue !== 'a'
                    }"
                  >
                  @if ($comp.feature633IsOn && $comp.feature633StringValue !== 'a') {
                    {{ getCurrencyWithSuffix(currency) }}
                  } @else {
                    <span class="dropdown-item"> {{ currency.description }}</span>
                  }
                  </li>
                </ul>
              </div>
              <div
                *ngIf="$comp.mobileStyle || $comp.isFlowPage"
                class="navigation"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-label="Toggle navigation"
                [attr.aria-expanded]="!collapseNavigation"
                aria-controls="navbarSupportedContent"
              >
                <input
                  #burgerInput
                  type="checkbox"
                  [checked]="!collapseNavigation"
                  class="toggle-menu"
                  (change)="collapseNavigation = !collapseNavigation"
                />
                <div class="hamburger"></div>
              </div>
            </div>
          </div>
        </div>

        <div
          #navbarSupportedContent
          class="collapse navbar-collapse"
          [collapse]="collapseNavigation"
          id="navbarSupportedContent"
          *ngIf="!$comp.isFlowPage || true"
        >
          <accordion [isAnimated]="true">
            <accordion-group
              #currencyGroup
              class="menu-accordion"
              [isDisabled]="
                !$comp.isHomePage && $comp.bookingCurrency ? true : false
              "
            >
              <div
                accordion-heading
                class="toggle-container flex-toggle-container"
                [ngClass]="{ collapsed: !currencyGroup.isOpen }"
                [attr.aria-expanded]="!currencyGroup.isOpen"
              >
                <span class="d-flex align-items-center icon-gap">
                  <div class="fa-solid fa-coins"></div>
                  <div>
                    {{ cmsCopy.currency }} ({{
                      getSelectedCurrencyWithPrefixSuffix(
                        $comp.selectedCurrencyPrefix,
                        $comp.selectedCurrencySuffix,
                        $comp.selectedCurrency
                      )
                    }})
                  </div>
                </span>
                <i class="toggle-chevron"></i>
              </div>
              <div *ngIf="$comp.isHomePage || !$comp.bookingCurrency">
                <div
                  class="nav-accordion-item"
                  *ngFor="let currency of $comp.currencies"
                  [ngClass]="{
                    active: currency.currencyCode === $comp.selectedCurrency
                  }"
                  (click)="
                    changeCurrency(
                      currency.currencyCode,
                      $comp.isFlightsPage ?? false,
                      $comp.selectedCurrency
                    )
                  "
                >
                  <span>{{ currency.description }}</span>
                </div>
              </div>
            </accordion-group>
          </accordion>
          @if (is3322TopMenuReorderingEnabled && $comp.navbarCopy && $comp.mobileStyle) {
              <app-top-navbar
                [cmsCopy]="cmsAppCopy.header"
                [loggedInUser]="$comp.loggedInUser"
                [currentValue]="$comp.currentFeat3322Value"
                [navbarCopy]="$comp.navbarCopy"
                [isMobile]="$comp.mobileStyle"
                (bookClick)="onBookClick()"
                (openLoginModal)="openLoginModal()"
                (logoutClick)="logOut()"
              ></app-top-navbar>
          } @else if (is1433TopMenuReorderingEnabled) {
            <app-top-menu-mobile
              [headerCopy]="cmsAppCopy.header"
              (bookNowClick)="onBookClick(true)"
            ></app-top-menu-mobile>
          } @else {
            <div *ngIf="$comp.stations" class="nav-item" (click)="onBookClick()">
              <span class="d-flex align-items-center icon-gap">
                <div class="fa-kit fa-book"></div>
                <div>{{ cmsCopy.book.name }}</div>
              </span>
            </div>
            @if ($comp.feature1893IsOn && cmsCopy.cars && $comp.stations) {
              <div [routerLink]="cmsCopy.cars.link" class="nav-item">
              <span class="d-flex align-items-center icon-gap">
                <app-svg-icon icon="car-menu" [width]="20" [height]="20"></app-svg-icon>
                <div>{{ cmsCopy.cars.name }}</div>
              </span>
              </div>
            }
            <div [routerLink]="cmsCopy.support.link" class="nav-item">
              <span class="d-flex align-items-center icon-gap">
                <div class="fa-kit fa-support"></div>
                <div>{{ cmsCopy.support.name }}</div>
              </span>
            </div>
            <div
              *ngIf="
                $comp.feature2688IsOn &&
                $comp.stations
              "
              [routerLink]="cmsCopy.checkIn.link"
              class="nav-item"
            >
              <span class="d-flex align-items-center icon-gap">
                <i class="fa-kit fa-check-in"></i>
                {{ cmsCopy.checkIn.name }}
              </span>
            </div>
            <div
              *ngIf="$comp.stations"
              [routerLink]="cmsCopy.trips.link"
              class="nav-item"
            >
              <span class="d-flex align-items-center icon-gap">
                <div class="fa-kit fa-your-trips"></div>
                <div>{{ cmsCopy.trips.name }}</div>
              </span>
            </div>
            <div
              *ngIf="
                featureFlagService.isFeatureActive(FeatureFlagsEnum.FLIFO) &&
                $comp.stations
              "
              class="nav-item"
              [routerLink]="cmsCopy.flightStatus.link"
            >
              <span class="d-flex align-items-center icon-gap">
                <div class="fa-kit fa-flight-status"></div>
                <div>{{ cmsCopy.flightStatus.name }}</div>
              </span>
            </div>
          }
          <span
            *ngIf="
              featureFlagService.isFeatureActive(FeatureFlagsEnum.LOG_IN) &&
              $comp.stations
            "
          >
            <div
              class="nav-item"
              *ngIf="!$comp.loggedInUser; else loggedIn"
              (click)="openLoginModal()"
            >
              <span class="d-flex align-items-center icon-gap">
                <div class="fa-solid fa-user"></div>
                <div>{{ cmsCopy.login }}</div>
              </span>
            </div>
            <ng-template #loggedIn>
              <accordion [isAnimated]="true">
                <accordion-group #loginGroup class="menu-accordion">
                  <div
                    accordion-heading
                    class="toggle-container flex-toggle-container"
                    [ngClass]="{ collapsed: !loginGroup.isOpen }"
                    [attr.aria-expanded]="!loginGroup.isOpen"
                  >
                    <span class="d-flex align-items-center icon-gap">
                      <div class="fa-solid fa-user"></div>
                      <div>{{ $comp.loggedInUser?.name?.first }}</div>
                    </span>
                    <i class="toggle-chevron"></i>
                  </div>

                  <div
                    [routerLink]="cmsCopy.yourAccount.link"
                    class="nav-accordion-item"
                  >
                    {{ cmsCopy.yourAccount.name }}
                  </div>
                  <div (click)="logOut()" class="nav-accordion-item">
                    {{ cmsCopy.logout }}
                  </div>
                </accordion-group>
              </accordion>
            </ng-template>
          </span>
        </div>
      </nav>
      <ng-container
        *ngIf="
          $comp.isFlightsPage && !$comp.isUpgradePath && $comp.showModifyNavbar
        "
      >
        <div
          id="modifyFlightsContent"
          class="flex-grow-1 col-12 col-lg pointer mb-2"
        >
          <div class="container search-widget-container justify-content-center">
            <app-modify-search-criteria
              [tripType]="$comp.tripType"
              [searchInput]="$comp.searchInput"
              [stations]="$comp.stations"
              [travelers]="getselectedTravelerCount($comp.searchInput)"
              [cmsAppCopy]="cmsAppCopy"
              [disabled]="$comp.isModifyPath ?? true"
              (modifyClick)="onModifyClick()"
            ></app-modify-search-criteria>
          </div>
        </div>
      </ng-container>
    </div>
  </header>
  <ng-template #currencyPickerDisabled>
    @if ($comp.feature633StringValue === 'c') {
      <div class="currency-picker-tooltip">
        {{cmsCopy.currencyDisabledVariantC}}. <span class="currency-picker-tooltip__link" [routerLink]="[$comp.cultureCode]">{{cmsCopy.newSearch}}</span> {{cmsCopy.modifySettings}}.
      </div>
    }
    @if ($comp.feature633StringValue === 'd') {
      <div class="currency-picker-tooltip">
        {{cmsCopy.currencyDisabledVariantD}}
      </div>
    }
  </ng-template>
</ng-container>


